const zh = {
  // Navbar
  'nav.products': '产品中心',
  'nav.home': '首页',
  'nav.about': '关于我们',
  'nav.services': '产品系列',
  'nav.portfolio': '应用案例',
  'nav.scenarios': '应用场景',
  'nav.team': '核心团队',
  'nav.contact': '联系我们',
  'nav.cta': '立即咨询',

  // Hero
  'hero.badge': '半导体及显示面板特种灯源专家',
  'hero.title1': '做高端制造领域的',
  'hero.title2': '"点亮者"',
  'hero.desc': '普像光学(ONOPTO)致力于打破高端制造领域的光源技术壁垒，为全球半导体及面板行业的顶级客户提供极致精密、稳定可靠的光刻与热处理光源解决方案。',
  'hero.btn1': '探索产品系列',
  'hero.btn2': '查看应用案例',
  'hero.stat1.value': '三系列',
  'hero.stat1.label': '产品覆盖全面',
  'hero.stat2.value': 'R&D',
  'hero.stat2.label': '研产销一体',
  'hero.stat3.value': '半导体',
  'hero.stat3.label': '高端应用领域',
  'hero.stat4.value': '面板显示',
  'hero.stat4.label': '显示行业覆盖',
  'hero.scroll': '向下滚动',

  // About
  'about.badge': '关于我们',
  'about.overlay.title': '高端应用专业认证',
  'about.overlay.sub': '半导体及面板行业品质标准',
  'about.accent.label': '核心特种灯源系列',
  'about.title1': '专注特种灯源',
  'about.title2': '用心制作每颗灯',
  'about.desc1': 'ONOPTO 普像光学自2024年正式面向半导体及面板高端应用领域，核心提供高压汞灯、卤素加热灯及UV灯全系列产品。我们的光源精准应用于光刻机曝光、热处理退火及面板固胶工艺，以高稳定性、高能量密度和长寿命著称。',
  'about.desc2': '致力于通过自研技术助力客户国产化替代，成为半导体及显示面板制造领域值得信赖的光源合作伙伴。团队成员60%以上均是半导体及显示面板行业资深从业人员，职业生涯贯穿上游材料开发、中游应用工艺、到下游设备制造的完整产业链。',
  'about.m1.label': '研发驱动',
  'about.m1.value': '研产销一体化运营',
  'about.m2.label': '半导体应用',
  'about.m2.value': '光刻 / 热处理 / 外延 /\u00a0 检测',
  'about.m3.label': '面板显示',
  'about.m3.value': '配向灯 / 固化灯 / 大面积曝光',
  'about.m4.label': '客户信赖',
  'about.m4.value': '超30家客户稳定使用ONOPTO产品',
  'about.btn': '联系我们了解更多',

  // Services
  'services.badge': '产品系列',
  'services.title1': '核心产品',
  'services.title2': '四大系列',
  'services.desc': '覆盖半导体光刻、热处理、检测及面板显示全工艺链，为高端制造提供可靠特种灯源支撑。',
  'services.s1.title': '光刻机高压汞灯',
  'services.s1.titleEn': 'Lithography High-Pressure Mercury Lamps',
  'services.s1.desc': '专为光刻机设计的高压汞灯，具有极高的紫外线输出强度与稳定性，确保光刻工艺中的精准曝光，满足半导体制造对微纳级图形的苛刻要求。',
  'services.s1.f1': '高紫外输出强度',
  'services.s1.f2': '长寿命稳定放电',
  'services.s1.f3': '严格一致性管控',
  'services.s2.title': '检测设备氙灯',
  'services.s2.titleEn': 'Detection Equipment Xenon Lamps',
  'services.s2.desc': '适用于半导体及面板检测设备的高性能氙灯，提供宽光谱、高亮度、高稳定性的光源输出，保障光学检测系统对微缺陷的精准识别能力。',
  'services.s2.f1': '宽光谱连续输出',
  'services.s2.f2': '高亮度稳定发光',
  'services.s2.f3': '快速启动响应',
  'services.s3.title': '半导体RTP & EPI加热灯',
  'services.s3.titleEn': 'Semiconductor RTP & EPI Heating Lamps',
  'services.s3.desc': '为半导体快速热处理（RTP）及外延生长（EPI）设备提供高功率卤钨加热灯，确保晶圆在热处理过程中温度均匀、响应迅速、工艺稳定可靠。',
  'services.s3.f1': '高功率均匀加热',
  'services.s3.f2': '快速热响应特性',
  'services.s3.f3': '长寿命耐高温设计',
  'services.s4.title': '面板配向灯 & 固化灯',
  'services.s4.titleEn': 'Panel Alignment & Curing Lamps',
  'services.s4.desc': '专为面板显示行业设计的配向曝光灯与UV固化灯，提供精准波长的紫外光输出，满足液晶取向处理及光固化工艺的高效稳定需求。',
  'services.s4.f1': '精准UV波长输出',
  'services.s4.f2': '高均匀度照射',
  'services.s4.f3': '适配多类面板工艺',

  // Portfolio
  'portfolio.badge': '应用案例',
  'portfolio.title1': '应用场景',
  'portfolio.title2': '',
  'portfolio.desc': '覆盖半导体光刻、热处理、检测及面板显示全工艺链的特种灯源实际应用案例。',
  'portfolio.cat.all': '全部',
  'portfolio.cat.litho': '光刻',
  'portfolio.cat.xenon': '检测',
  'portfolio.cat.rtp': 'RTP/EPI',
  'portfolio.cat.align': '配向',
  'portfolio.cat.cure': '固化灯',
  'portfolio.p1.category': '半导体光刻',
  'portfolio.p1.title': '主流光刻机高压汞灯替代方案',
  'portfolio.p1.desc': '为国内某头部半导体制造商提供光刻机高压汞灯稳定供应，实现进口替代，有效降低采购成本，产品一致性与寿命达到国际同类水平。',
  'portfolio.p1.tag': '光刻',
  'portfolio.p2.category': '半导体检测',
  'portfolio.p2.title': '晶圆缺陷检测光源',
  'portfolio.p2.desc': '为半导体检测设备厂商定制高亮度氙灯光源模组，提升晶圆表面微缺陷检出率，有效支持良率管控需求。',
  'portfolio.p2.tag': '检测',
  'portfolio.p3.category': 'RTP快速退火',
  'portfolio.p3.title': 'RTP快速退火设备加热灯配套',
  'portfolio.p3.desc': 'RTP快速热处理设备专用卤钨加热灯，满足晶圆高温均匀退火需求，产品耐高温性能稳定，批次一致性优异。',
  'portfolio.p3.tag': '热处理',
  'portfolio.p4.category': '面板配向',
  'portfolio.p4.title': '面板配向应用',
  'portfolio.p4.desc': '为大尺寸LCD面板生产线提供UV配向灯解决方案，确保液晶分子取向处理的均匀性与稳定性，支持高世代面板产线的高效量产需求。',
  'portfolio.p4.tag': '配向',
  'portfolio.p5.category': '面板固化',
  'portfolio.p5.title': '封装UV固化',
  'portfolio.p5.desc': '为OLED面板封装产线提供高功率紫外固化灯，精准输出特定波长UV光，满足封装胶快速固化工艺要求，助力面板良率与产能提升。',
  'portfolio.p5.tag': '固化',
  'portfolio.p6.category': 'EPI外延生长',
  'portfolio.p6.title': 'EPI外延生长灯源配套',
  'portfolio.p6.desc': '为化合物半导体外延生长设备提供专用加热灯组，满足MOCVD等工艺对均匀加热、高温稳定性及灯源寿命的严苛要求，保障外延片质量一致性。',
  'portfolio.p6.tag': 'EPI',

  // Team
  'team.badge': '核心团队',
  'team.title1': '专业团队',
  'team.title2': '驱动创新',
  'team.desc': 'ONOPTO 团队汇聚光学工程、半导体工艺、面板显示及商业运营等多领域专业人才，共同推动特种灯源技术与应用的持续突破。',
  'team.t1.title': '创始人 & 总经理',
  'team.t1.bio': '同济大学机械自动化本科，ONOPTO 普像光学创始人。主导公司战略规划与整体运营管理，凭借丰富的光电行业资源与深厚的产业经验，带领团队从零构建特种灯源研产销一体化体系，推动 ONOPTO 在半导体与面板高端市场的专业化发展。',
  'team.t2.title': '汞灯研发负责人',
  'team.t2.bio': '浙江大学机械系学士，曾任上海华虹NEC后道封测经理、泊松半导体应用材料高真空系统技术副总，深耕半导体制造与高真空系统领域。凭借对封装测试与真空系统设计的深刻理解，主导汞灯系列产品研发，聚焦性能提升与工艺创新，为产品技术迭代、质量管控及产业化落地提供核心支撑。',
  'team.t3.title': '加热灯研发负责人',
  'team.t3.bio': '上海大学机械自动化硕士，曾任职上海华虹NEC、瑞典奥托立夫，深耕精密制造与光电技术领域多年，兼具半导体设备工程化落地与电控系统研发实战经验。精通高可靠性、极端工况下光学组件的结构设计与性能优化，聚焦加热灯热效率提升与环境适应性突破，为产品稳定量产提供核心技术保障。',
  'team.t4.title': 'UV灯研发 / 产品线品质负责人',
  'team.t4.bio': '北京工业大学物理系硕士，曾任中航光电子检测经理、和辉光电光学良率经理，深耕光学检测与品控领域多年，精通UV灯核心技术研发与全流程质量管控。',
  'team.t5.title': '创始人 & 副总经理',
  'team.t5.bio': '上海应用技术大学机械自动化本科，ONOPTO 普像光学联合创始人。协同主导公司财务管理与内部运营，在企业资金规划、成本管控及经营合规方面发挥核心作用，助力公司稳健发展与可持续增长。',
  'team.t6.title': '股东 & 销售总监',
  'team.t6.bio': '韩国汉阳大学机械工程本科，ONOPTO 普像光学股东。主管公司销售业务，深耕半导体及面板客户资源，凭借对行业需求的精准把握与丰富的市场拓展经验，持续推动公司客户网络扩张与销售规模增长。',
  'team.cta.title': '加入我们',
  'team.cta.desc': '我们持续寻找对半导体光源、光学工程及高端制造充满热情的专业人才，期待与您共同探索特种灯源技术的无限可能。',
  'team.cta.btn': '查看招聘职位',

  // Contact
  'contact.badge': '联系我们',
  'contact.title1': '',
  'contact.title2': '',
  'contact.desc': '产品需求、技术咨询、合作意向？请留下您信息，ONOPTO 在24小时内联系您。',
  'contact.info1.label': '邮箱',
  'contact.info1.value': 'info@onopto.com',
  'contact.info2.label': '工作时间',
  'contact.info2.value': '周一至周五  09:00 – 18:00',
  'contact.info3.label': '业务咨询',
  'contact.info3.value': '欢迎就产品选型、定制需求等进行咨询',
  'contact.form.name': '姓名',
  'contact.form.namePh': '您的姓名',
  'contact.form.email': '邮箱',
  'contact.form.emailPh': 'your@company.com',
  'contact.form.company': '公司名称',
  'contact.form.companyPh': '您所在的公司',
  'contact.form.service': '感兴趣的产品',
  'contact.form.servicePh': '请选择产品类别',
  'contact.form.message': '留言',
  'contact.form.messagePh': '请描述您的产品需求、设备型号或合作意向...',
  'contact.form.required': '*',
  'contact.form.submit': '发送消息',
  'contact.form.submitting': '发送中...',
  'contact.form.charCount': '{{count}}/500',
  'contact.form.err.required': '请填写所有必填项。',
  'contact.form.err.tooLong': '留言内容不能超过500字。',
  'contact.form.err.failed': '提交失败，请重试。',
  'contact.form.err.network': '网络错误，请重试。',
  'contact.success.title': '消息已发送！',
  'contact.success.desc': '感谢您联系 ONOPTO 普像光学，我们的团队将在24小时内与您取得联系。',
  'contact.opt.litho': '光刻机高压汞灯',
  'contact.opt.xenon': '检测设备氙灯',
  'contact.opt.rtp': '半导体RTP加热灯',
  'contact.opt.epi': '半导体EPI加热灯',
  'contact.opt.align': '面板配向灯',
  'contact.opt.cure': '面板固化灯',
  'contact.opt.other': '其他',

  // Footer
  'footer.brand.desc': 'ONOPTO 普像光学专注半导体及面板高端应用领域特种灯源，集研发、生产、销售于一体，为高端制造提供可靠光源支撑。',
  'footer.s1.title': '产品系列',
  'footer.s2.title': '公司信息',
  'footer.s3.title': '应用领域',
  'footer.s4.title': '联系我们',
  'footer.s1.l1': '光刻机高压汞灯',
  'footer.s1.l2': '检测设备氙灯',
  'footer.s1.l3': '半导体RTP加热灯',
  'footer.s1.l4': '半导体EPI加热灯',
  'footer.s1.l5': '面板配向灯 & 固化灯',
  'footer.s2.l1': '关于我们',
  'footer.s2.l2': '核心团队',
  'footer.s2.l3': '加入我们',
  'footer.s2.l4': '应用案例',
  'footer.s2.l5': '合作伙伴',
  'footer.s3.l1': '半导体光刻工艺',
  'footer.s3.l2': '半导体热处理设备',
  'footer.s3.l3': '晶圆光学检测',
  'footer.s3.l4': 'LCD面板配向',
  'footer.s3.l5': 'OLED封装固化',
  'footer.s4.l1': 'info@onopto.com',
  'footer.s4.l2': '产品咨询',
  'footer.s4.l3': '定制需求',
  'footer.s4.l4': '技术支持',
  'footer.s4.l5': '商务合作',
  'footer.wechat.label': '关注公众号',
  'footer.wechat.sub': '扫码关注 ONOPTO',
  'footer.bottom.copyright': '© {{year}} ONOPTO 普像光学. 保留所有权利。',
  'footer.bottom.privacy': '隐私政策',
  'footer.bottom.terms': '使用条款',
  'footer.bottom.contact': '联系我们',

  // Table Headers
  'table.image': '产品图',
  'table.onopto_model': '普像型号',
  'table.oem_model': '原厂型号',
  'table.power': '额定功率',
  'table.current': '额定电流',
  'table.voltage': '额定电压',
  'table.note': '备注',
  'table.equipment': '适用设备',
  'table.color_temp': '色温',
  'table.length': '长度',
  'table.name': '产品名称',
  'table.spec': '规格参数',
  'table.custom': '如需定制规格，请联系我们',

  // 产品页面
  'products.badge': '特种灯源产品中心',
  'products.hero.title1': '三大系列',
  'products.hero.title2': '光耀未来',
  'products.hero.desc': 'ONOPTO 汞灯、加热灯、UV灯三大核心产品系列，覆盖半导体与面板显示全工艺链，为每一道关键工序提供高性能特种光源解决方案。',
  'products.mascot.label': '系列吉祥物机器人展示',
  'products.series.mercury.name': '汞灯系列',
  'products.series.mercury.desc': '专为半导体光刻设备设计的高压汞灯，具备极高的紫外光输出稳定性与超长使用寿命，满足图形曝光工艺的严苛要求，支持i线、g线、h线等多种光刻工艺需求。',
  'products.series.mercury.p1.model': 'ONM-365',
  'products.series.mercury.p1.name': 'i-line 365nm 高压汞灯',
  'products.series.mercury.p1.spec': '365nm | 1000W–5000W | 寿命≥1500h',
  'products.series.mercury.p1.app': '适用于主流半导体设备的i-line光刻曝光系统',
  'products.series.mercury.p2.model': 'ONM-436',
  'products.series.mercury.p2.name': 'g-line 436nm 高压汞灯',
  'products.series.mercury.p2.spec': '436nm | 500W–2000W | 寿命≥2000h',
  'products.series.mercury.p2.app': '应用于PCB及半导体后段封装设备的g线光刻工艺',
  'products.series.mercury.p3.model': 'ONM-405',
  'products.series.mercury.p3.name': 'h-line 405nm 高压汞灯',
  'products.series.mercury.p3.spec': '405nm | 500W–3000W | 寿命≥2000h',
  'products.series.mercury.p3.app': '用于对均匀性和稳定性要求较高的h线光刻系统',
  'products.series.mercury.p4.model': 'ONM-UHP',
  'products.series.mercury.p4.name': 'UHP 超高压汞灯',
  'products.series.mercury.p4.spec': '宽带UV | 200W–1000W | 高亮度',
  'products.series.mercury.p4.app': '用于UV曝光检测及高亮度光学系统',
  'products.series.heating.name': '加热灯系列',
  'products.series.heating.desc': '为半导体RTP快速热处理及EPI外延生长设备提供的高功率卤钨加热灯，确保晶圆在热处理过程中温度均匀分布、热响应迅速，具备优异的高温稳定性与批次一致性。',
  'products.series.heating.p1.model': 'ONH-RTP',
  'products.series.heating.p1.name': 'RTP单管卤钨加热灯',
  'products.series.heating.p1.spec': '1000W–3000W/支 | 最高温度≥1200°C',
  'products.series.heating.p1.app': '适用于晶圆快速热退火、氧化、氮化等热处理工艺',
  'products.series.heating.p2.model': 'ONH-EPI',
  'products.series.heating.p2.name': 'EPI环形加热灯组',
  'products.series.heating.p2.spec': '多区控制 | 高温均匀性≤±1%',
  'products.series.heating.p2.app': '用于MOCVD等化合物半导体及硅外延生长设备',
  'products.series.heating.p3.model': 'ONH-MZ',
  'products.series.heating.p3.name': '多区加热灯模组',
  'products.series.heating.p3.spec': '3–12区 | 功率可定制配置',
  'products.series.heating.p3.app': '高精度多区温控先进热处理设备',
  'products.series.heating.p4.model': 'ONH-LN',
  'products.series.heating.p4.name': '线型阵列加热灯',
  'products.series.heating.p4.spec': '线型 | 快速热响应 | 长寿命',
  'products.series.heating.p4.app': '用于带式炉及连续式热处理生产线',
  'products.series.uv.name': 'UV灯系列',
  'products.series.uv.desc': '面板显示行业的精密UV光源，配向、固化灯，提供精准波长输出与高均匀度照射，满足面板每道工艺环节的高效稳定需求。',
  'products.series.uv.p1.model': 'ONU-ALN',
  'products.series.uv.p1.name': 'LCD紫外配向曝光灯',
  'products.series.uv.p1.spec': '254nm / 313nm | 高均匀度 | 长寿命',
  'products.series.uv.p1.app': 'TFT-LCD面板产线液晶分子取向处理',
  'products.series.uv.p2.model': 'ONU-CUR',
  'products.series.uv.p2.name': 'UV固化灯',
  'products.series.uv.p2.spec': '300–400nm | 高功率密度 | 快速固化',
  'products.series.uv.p2.app': 'OLED封装及面板显示工艺中的封装胶固化',
  'products.series.uv.p3.model': 'ONU-XEN',
  'products.series.uv.p3.name': '检测氙灯光源',
  'products.series.uv.p3.spec': '宽光谱 | 高亮度 | 寿命≥5000h',
  'products.series.uv.p3.app': '半导体晶圆表面缺陷检测及光学检测设备',
  'products.series.uv.p4.model': 'ONU-DEP',
  'products.series.uv.p4.name': '深紫外固化灯',
  'products.series.uv.p4.spec': '185nm–254nm | 深紫外输出',
  'products.series.uv.p4.app': '先进基板表面处理及深紫外光刻工艺',
  'products.hero.explore': '浏览三大系列',
  'products.cta.title': '需要定制化方案？',
  'products.cta.desc': '我们的工程团队根据您的设备型号与工艺需求，提供定制化特种灯源解决方案。欢迎联系我们进行产品选型、样品测试或批量采购咨询。',
  'products.cta.btn1': '联系我们',
  'products.cta.btn2': '返回首页',
};

export default zh;
